import { IModelService, IRequestResult, IModelQuery } from '../schemas/structure';
import { IContact } from '../schemas/entity_set';
import { AngularServices, AppServices } from '../helpers/config_keys';

interface IContactQuery extends IModelQuery {
}

interface IContactService extends IModelService<IContact> {
	upload(patients: IContact[]): angular.IPromise<IRequestResult<boolean>>
	query(params: IContactQuery): angular.IPromise<IRequestResult<Array<IContact>>>
}

class ContactService implements IContactService {

	static $inject = [AngularServices.Q, AngularServices.Http, AppServices.BaseApi];

	constructor(private $q: angular.IQService,
		private $http: angular.IHttpService,
		private baseUrl: string) { }

	get() {
		let defer = this.$q.defer<IRequestResult<Array<IContact>>>()
		this.$http.get(`${this.baseUrl}/contact`)
			.then((response: IRequestResult<Array<IContact>>) => {
				defer.resolve(response);
			});
		return defer.promise;
	}

	upload(contacts: IContact[]) {
		let defer = this.$q.defer<IRequestResult<boolean>>();
		this.$http.post(`${this.baseUrl}/contact/upload`, contacts).then((response: IRequestResult<boolean>) => {
			defer.resolve(response)
		})
		return defer.promise
	}

	find(id: number) {
		let defer = this.$q.defer<IRequestResult<IContact>>();
		this.$http.get(`${this.baseUrl}/contact?id=${id}`)
			.then((response: IRequestResult<IContact>) => {
				defer.resolve(response);
			});
		return defer.promise;
	}

	query(params: IContactQuery) {
		let defer = this.$q.defer<IRequestResult<Array<IContact>>>();
		this.$http.post(`${this.baseUrl}/contact/query`, params)
			.then((response: IRequestResult<Array<IContact>>) => {
				defer.resolve(response);
			});
		return defer.promise;
	}

	save(contact: IContact) {
		let defer = this.$q.defer<IRequestResult<IContact>>();
		if (contact.id) {
			this.$http.put(`${this.baseUrl}/contact`, contact)
				.then((response: IRequestResult<IContact>) => {
					defer.resolve(response);
				});
		} else {
			this.$http.post(`${this.baseUrl}/contact`, contact)
				.then((response: IRequestResult<IContact>) => {
					defer.resolve(response);
				});
		}
		return defer.promise;
	}

	delete(id: number) {
		let defer = this.$q.defer<IRequestResult<IContact>>();
		this.$http.delete(`${this.baseUrl}/contact?id=${id}`)
			.then((response: IRequestResult<IContact>) => {
				defer.resolve(response);
			});
		return defer.promise
	}

}

export { ContactService, IContactService, IContactQuery }


// WEBPACK FOOTER //
// ./app/address/contact_service.ts